import { ApiService } from "@/api";

export default {
  UPDATE_INTERCOM(context, { id, data }) {
    return ApiService.intercoms.update(id, data);
  },
  GET_INTERCOM({ commit }, id) {
    return ApiService.intercoms.get(id).then((intercom) => commit("SET_INTERCOM", intercom));
  },
  ADD_INTERCOM(context, newIntercom) {
    return ApiService.intercoms.create(newIntercom).then((data) => data.id_intercom);
  },
  DELETE_INTERCOM(context, id) {
    return ApiService.intercoms.delete(id);
  },
};
